var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9963 15.6568C13.8705 16.5981 16.5375 15.3316 16.786 15.182C18.4186 14.1991 19.5432 11.7001 19.5432 10.5839V4.55203C19.5432 4.52504 19.5453 4.49798 19.5499 4.47139C19.7301 3.44365 20.3502 2.60985 20.6107 2.3048C20.6733 2.23151 20.722 2.14537 20.7355 2.04993C20.8451 1.27007 20.3062 1.32993 20.0596 1.32992",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 16.2734C10.8125 15.8364 11.2014 15.6453 11.4302 15.5727C11.4711 15.5597 11.514 15.5541 11.5569 15.5564C11.8202 15.5701 12.0307 15.6637 12.113 15.7151",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38202 8.818V22.1789C6.38202 22.455 6.15816 22.6789 5.88202 22.6789H3.75C3.47386 22.6789 3.25 22.455 3.25 22.1789V8.818C3.25 2.98046 8.13684 1.38779 10.5803 1.32115",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68147 8.81801V22.1789C7.68147 22.455 7.90533 22.6789 8.18147 22.6789H10.3135C10.5896 22.6789 10.8135 22.455 10.8135 22.1789V16.2482",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4128 8.9846H14.645C14.9212 8.9846 15.145 8.76075 15.145 8.4846V6.35258C15.145 6.07644 14.9212 5.85258 14.645 5.85258H10.8468",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4445 10.484V4.98649C16.4445 4.71035 16.2206 4.48649 15.9445 4.48649H10.8135",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 1.32115H20.0763",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38202 8.88464C6.38202 5.4994 9.35855 4.53091 10.8468 4.48649",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68147 8.91797C7.68147 6.57228 9.83612 5.89701 10.9134 5.85258",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4586 8.9846C11.1658 9.05124 10.7871 10.223 10.7594 10.8005C10.7594 12.2932 11.8922 12.733 12.4586 12.7664H14.6411C15.8697 12.7247 16.4 11.2142 16.4445 10.4423",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/Employee.7cc74d0c4776a6b55e1715e78520e633.svg";
export { ForwardRef as ReactComponent };